import React from "react";
import AboutImg1 from "../../assets/images/doctor-supporting.png";
import CheckIcon from "../../assets/icons/green-tic.svg";
import CustomButton from "../Form/CustomButton";

const SupportedLiving = () => {
  return (
    <section className="py-10 px-10 font-poppins xl:mb-[100px]">
      <div className="max-w-screen-xl mx-auto">
        {/* Top Part */}
        <div className="flex flex-col-reverse md:flex-row gap-0 md:gap-[40px] lg:gap-[70px] mb-10 sm:mb-12 lg:h-[500px]">
          {/* Right - Image Section */}
          <div className="flex-[1.3] w-full h-full">
            <img
              src={AboutImg1}
              loading="lazy"
              decoding="async"
              fetchpriority="low"
              alt="Services"
              className="rounded-xl w-full h-full object-cover object-top lg:object-fill"
            />
          </div>

          {/* Left - Text Section */}
          <div className="flex-[0.8] h-full flex flex-col justify-between font-poppins sm:text-left">
            <div>
              <h4 className="text-[var(--primary-orange-color)] text-[24px] lg:text-[32px] xl:text-[36px] font-semibold mb-2 uppercase whitespace-nowrap">
                SUPPORTED LIVING
              </h4>

              <h2 className="text-[14px] lg:text-[22px] xl:text-[25px] font-semibold text-green mb-6">
                Independence for Young Adults
              </h2>

              <ul className="mb-8 md:mb-4 space-y-5 xl:space-y-8">
                {[
                  "Personalized support that adapts to each individual’s goals and pace",
                  "Skill-building in areas like cooking, budgeting, travel training, and self-care",
                  "Community engagement to build confidence and social connections",
                  "Flexible staffing to provide the right balance of support and autonomy",
                ].map((item, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <img
                      src={CheckIcon}
                      alt="Check"
                      loading="lazy"
                      decoding="async"
                      fetchpriority="low"
                      className="w-5 h-5 lg:w-6 lg:h-6 xl:w-8 xl:h-8"
                    />
                    <span className="text-[var(--light-gray-color)] text-[12px] lg:text-[18px] xl:text-[20px]">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportedLiving;
